import { TeamRole } from "app/types";
import { IAvatar } from "app/containers/Features/containers/TeamSettings/container/MySetting/types";

export enum TeamMemberStatus {
  ACTIVE = "active",
  INVITATION_PENDING = "invitation pending",
  INVITATION_REJECTED = "invitation rejected",
  INVITATION_EXPIRED = "invitation expired",
  IN_ACTIVE = "inactive",
}

export interface IMemberList {
  avatar: IAvatar;
  createdAt: string;
  email: string;
  name: string;
  role: TeamRole;
  status: TeamMemberStatus;
  updatedAt: string;
  userId: string;
  _id: string;
  isOwner: boolean;
  onlineStatus?: boolean;
  mobileNumber: string;
  lastLogin: string;
  timeZone: string;
}
export enum SearchForEnum {
  team = "Team",
  project = "Project",
}

export interface MemberSelectionProps {
  trigger: React.ReactNode;
  selectedValue: string | string[];
  containerClassName?: string;
  updateValue: (options: IMemberList) => void;
  dropdownContainerClassName?: string;
  className?: string;
  align?: "start" | "end" | "center";
  headingText?: string;
  onOpen?: () => void;
  onClose?: () => void;
  searchPlaceholder?: string;
  handleSelectAll?: () => void;
  options: IMemberList[];
  isFullWidth?: boolean;
  dropdownWidthClassName?: number;
  hideRole?: boolean;
  hideSearchIcon?: boolean;
  headerAreaClassName?: string;
  headingTextClassName?: string;
  inputNoBorder?: boolean;
  showSearch?: boolean;
  isMultiSelect?: boolean;
  showTooltipArrowIcon?: boolean; // show tooltip arrow icon
  arrowClassName?: string; // class for arrow UI
  onLoadMore?: () => void;
  hasMore?: boolean;
  isLoading?: boolean;
  isExternalSearch?: boolean;
  externalOnSearchChange?: (search: string) => void;
  externalSearchValue?: string;
  isMoreLoading?: boolean;
}
export interface MemberMenuItemProps<T> {
  options: T;
  className?: string;
  menuContentClassName?: string;
  searchPlaceholder?: string;
  onChange: (options: IMemberList) => void;
  align?: "center" | "start" | "end";
  dropdownWidth: number;
  value: string | string[];
  headingText?: string;
  isFullWidth?: boolean;
  isMultiSelect?: boolean;
  handleSelectAll: () => void;
  hideRole?: boolean;
  hideSearchIcon?: boolean;
  headerAreaClassName?: string;
  headingTextClassName?: string;
  inputNoBorder: boolean;
  showSearch?: boolean;
  showTooltipArrowIcon?: boolean; // show tooltip arrow icon
  arrowClassName?: string; // class for arrow UI
  onLoadMore?: () => void;
  hasMore?: boolean;
  isLoading?: boolean;
  isExternalSearch?: boolean;
  externalOnSearchChange?: (search: string) => void;
  externalSearchValue?: string;
  isMoreLoading?: boolean;
}

export interface MemberListState {
  projectMemberList: IMemberList[];
  teamMemberList: IMemberList[];
  isLoading: boolean;
}
